export const SET_ALL_DESKTOP_USERS = 'SET_ALL_DESKTOP_USERS'
export const SET_DESKTOP_SHOW_MODAL = 'SET_DESKTOP_SHOW_MODAL'
export const SET_DESKTOP_CLIENT_JSON = 'SET_DESKTOP_CLIENT_JSON'
export const SET_DESKTOP_IS_CONNECTING = 'SET_DESKTOP_IS_CONNECTING'
